import { BlocksResultProps } from "@grapesjs/react";
import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import { StyledDivider } from "Components/UI/StyledDivider";
import { AccordianChartBuilderSidebarBlock } from "features/chartLibrary";

type TCustomBlockManagerProps = Pick<
  BlocksResultProps,
  "mapCategoryBlocks" | "dragStart" | "dragStop"
>;

function LightningLandersElements({
  mapCategoryBlocks,
  dragStart,
  dragStop,
}: TCustomBlockManagerProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRight: `1px solid ${theme.palette.divider2}`,
        height: "100%",
      }}
    >
      <Typography p={1} variant="subtitle1">
        Elements
      </Typography>
      <StyledDivider colour="divider2" />
      {Array.from(mapCategoryBlocks)
        .sort(([a], [b]) => {
          // Define category order
          const categoryOrder = {
            'Basic': 1,
            'Grid': 2,
            'Forms': 3,
            'Extra': 4
          };
          const orderA = categoryOrder[a as keyof typeof categoryOrder] || 99;
          const orderB = categoryOrder[b as keyof typeof categoryOrder] || 99;
          return orderA - orderB;
        })
        .map(([key, value]) => (
          <AccordianChartBuilderSidebarBlock
            key={key}
            title={key}
            sx={{ padding: 2 }}
          >
            <Grid container spacing={2}>
              {mapCategoryBlocks
                .get(key)
                ?.slice()
                .sort((a, b) => {
                  // Use block order if set, otherwise sort by desired order: section, headings, text
                  const getOrder = (block: any) => {
                    if (
                      typeof block.getOrder === "function" &&
                      block.getOrder() != null
                    ) {
                      return block.getOrder();
                    }
                    // fallback: section-block=1, headings-block=2, text=3, else 99
                    const id = block.getId();
                    if (id === "section-block") return 1;
                    if (id === "headings-block") return 2;
                    if (id === "text") return 3;
                    return 99;
                  };
                  return getOrder(a) - getOrder(b);
                })
                .map((block) => (
                  <Grid
                    item
                    xs={4}
                    key={block.getId()}
                    draggable
                    onDragStart={(ev) => dragStart(block, ev.nativeEvent)}
                    onDragEnd={() => dragStop(false)}
                  >
                    <Stack justifyContent={"center"} alignItems={"center"}>
                      <Box
                        mb={1}
                        sx={{
                          width: "100%",
                          backgroundColor: "#e4e6f8",
                          aspectRatio: "1 / 1",
                          color: theme.palette.primary.main,
                          fill: theme.palette.primary.main,
                          borderRadius: 4,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        p={2}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          dangerouslySetInnerHTML={{ __html: block.getMedia()! }}
                        />
                      </Box>
                      <Typography variant="subtitle2">
                        {block.getLabel()}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
            </Grid>
          </AccordianChartBuilderSidebarBlock>
        ))}
    </Box>
  );
}

export default LightningLandersElements;
